<template>
    <Primitive
        :as="as"
        :class="classes"
        :aria-label="label || undefined"
        :aria-hidden="visible ? undefined : true"
        :inert="visible ? undefined : true"
        :data-state="visible ? 'open' : 'closed'"
    >
        <div :class="element('inner')">
            <div :class="element('summary')">
                <slot />
            </div>

            <div
                v-if="$slots.actions || $slots.secondary || $slots.primary"
                :class="element('actions')"
            >
                <slot name="actions" />
                <div
                    v-if="$slots.secondary"
                    :class="element('secondary')"
                >
                    <slot name="secondary" />
                </div>
                <div
                    v-if="$slots.primary"
                    :class="element('primary')"
                >
                    <slot name="primary" />
                </div>
            </div>
        </div>
    </Primitive>
</template>

<script setup lang="ts">
import type { KActionBarProps } from './types'
import useBem from '@yeeroen/use-bem'
import { Primitive } from 'reka-ui'
import { computed } from 'vue'

defineOptions({ name: 'KActionBar' })

const props = withDefaults(defineProps<KActionBarProps>(), {
    as: 'aside',
    visible: false,
    label: 'Actions',
    presentation: 'floating',
    sticky: false,
})

defineSlots<{
    default?: () => unknown
    actions?: () => unknown
    secondary?: () => unknown
    primary?: () => unknown
}>()

const { block, element, modifier } = useBem('k-action-bar')
const classes = computed(() => block(
    modifier('visible', props.visible),
    modifier(props.presentation),
    modifier('sticky', props.presentation === 'form-footer' && props.sticky),
))
</script>

<style lang="scss">
@use './k-action-bar.scss';
</style>
